var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M19 4H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2ZM16 2v4M8 2v4M5 10h14"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }